import React, { useEffect } from "react";
import { Box, Chip } from "@mui/material";
import CInput from "../../../components/CInput";
import Cselect from "../../../components/CSelect";
import { isArray } from "lodash";
import { ReactComponent as WhiteCrossIcon } from "../../../assets/svg/WhiteCrossIcon.svg";

function CompanyInfo({
  state,
  setState,
  errObj,
  setErrObj,
  expertiseList,
  role,
  isMobile
}) {
  const data = [
    {
      heading: "Total years in business",
      options: [
        "0-1 year",
        "2-3 years",
        "4-7 years",
        "8-15 years",
        "16+ years",
      ],
      key: "businessYear",
    },
  ];

  if (role !== "designer") {
    data.push({
      heading: "Company size",
      options: [
        "1-10 employees",
        "11-50 employees",
        "51-200 employees",
        "200+ employees",
      ],
      key: "employees",
    });
  }

  const handleSelect = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const handleAddExpertise = (selectedItems) => {
    setState((prev) => ({
      ...prev,
      expertise: Array.isArray(prev.expertise)
        ? [...new Set([...prev.expertise, ...selectedItems])]
        : selectedItems,
    }));
    setErrObj({
      ...errObj,
      expertiseErr: false,
      expertiseMsg: "",
    });
  };

  const handleRemoveExpertise = (item) => {
    setState((prev) => ({
      ...prev,
      expertise: prev.expertise.filter((exp) => exp !== item),
    }));
    setErrObj({
      ...errObj,
      expertiseErr: false,
      expertiseMsg: "",
    });
  };

  const renderOptions = (key, options, heading) => {
    const filteredOptions = options.filter(
      (option) => !state.expertise?.includes(option)
    );

    return (
      <div
        style={{
          margin: "2vh 0",
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <h4
          style={{
            color: "#000000",
            fontSize: isMobile ? "16px" : "18px",
            fontWeight: "500",
            fontFamily: "Inter Tight",
          }}
        >
          {heading}
        </h4>
        <Box sx={{ display: "flex", gap: "10px" }}>
          {filteredOptions.map((option) => (
            <button
              key={option}
              onClick={() => handleSelect(key, option)}
              variant={state[key] === option ? "contained" : "outlined"}
              style={{
                borderRadius: "10px",
                padding: isMobile ? "1vh 2vw" : "1vh .8vw",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "12px",
                border:
                  state[key] === option
                    ? "1px solid #0D0D0D"
                    : "1px solid #D7D8D9",
                color: state[key] === option ? "#FFFFFF" : "#B5BECB",
                backgroundColor: state[key] === option ? "#0D0D0D" : "#fff",
                cursor: "pointer",
              }}
            >
              {option}
            </button>
          ))}
        </Box>
      </div>
    );
  };

  return (
    <>
      <div style={{ marginBottom: "1.5vh" }}>
        <CInput
          label={<span className="labelField">Company Name</span>}
          required
          placeholder="Enter your company name"
          value={state.cname}
          onChange={(e) => {
            setState({ ...state, cname: e.target.value });
            setErrObj({ ...errObj, cnameErr: false, cnameMsg: "" });
          }}
          inputProps={{ maxLength: 200 }}
          error={errObj.cnameErr}
          helpertext={errObj.cnameMsg}
        />
      </div>
      {data?.map((item) => renderOptions(item.key, item.options, item.heading))}

      <div
        style={{
          margin: "2vh 0",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h4
          style={{
            color: "#000000",
            fontSize: isMobile ? "16px" : "18px",
            fontWeight: "500",
            fontFamily: "Inter Tight",
          }}
        >
          {role === "contractor"
            ? "Contracting specialization"
            : role === "designer"
            ? "Design specialization"
            : "Inventory categorization"}
        </h4>
        <Cselect
          renderTags={expertiseList.filter(
            (option) => !state.expertise?.includes(option)
          )}
          multiple
          placeholder="Select Area of Expertise"
          handleSelect={(e) => handleAddExpertise(e)}
          error={errObj.expertiseErr}
          helpertext={errObj.expertiseMsg}
        />
        {isArray(state.expertise) && state.expertise.length > 0 && (
          <Box sx={{ marginTop: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
            {state.expertise.map((item) => (
              <Chip
                key={item}
                label={item}
                onDelete={() => handleRemoveExpertise(item)}
                deleteIcon={<WhiteCrossIcon />}
                sx={{
                  backgroundColor: "#0D0D0D",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "500",
                  borderRadius: "10px",
                  padding: "1vh .5vw",
                  marginTop: "0 !important",
                }}
              />
            ))}
          </Box>
        )}
      </div>
    </>
  );
}

export default CompanyInfo;
